export default "__VITE_ASSET__B7Vtl1ug__"